import { Component, Input, OnInit, Injectable, ElementRef, ViewChild, OnChanges, DoCheck, NgZone, Output, EventEmitter } from '@angular/core';
import { Util } from '../../util/Util';
import { TableOptions } from '../../../tsScripts/DTO/TableDTO';
declare let $: any, ReactDOM: any, React: any, Table: any;

@Component({
  selector: 'ltablereact-x',
  template: "<div></div>",
  providers: []
})
@Injectable()
export class LudyUIReact implements OnInit, DoCheck {

  @Input()
  options: TableOptions;

  @Output()
  onReady: EventEmitter<any>;
  
  private oldOptions: TableOptions;


  //    @ViewChild(options)
  //    private tabl    
  constructor(private element: ElementRef,
  private zone:NgZone) {
    this.oldOptions = new TableOptions();
    this.onReady = new EventEmitter();
  }

  link() {
    let selectedIds = {};
    let tableEL = $(this.element.nativeElement);
    let tableData = [];
    let enableSetScrollTop: boolean = false;
    let tableScrollTop: number = 0;
    let hasCheckbox: boolean = false;
    let shift_IsPress: boolean = false;
    let lastSelected: any = '';
    let lastcheckId: any = '';
    let scrollArea = undefined;
    let globalsortType: string = "";
    let globalTh = null;
    let originalRows = [];
    let options: TableOptions = this.options;
    let element = this.element.nativeElement;
    let renderEmptyLine = this.renderEmptyLine;
    let isMouseDown = false;
    let stop = false;
    let listNotSelectedTr = [];
    let listSelectedTr = [];
    let zone = this.zone;
    /**
     * lista temporal usada para recargar 
     * las filas seleccionadas despues de 
     * realizar un ordenamiento total
     */
    let tempList = [];
    /**
     * utilizada para saber si 
     * una consulta fue realizada por medio
     * de un ordenamiento o busqueda normal
     */
    let sortFlag = false;

    this.options.onBeforeLoadData = () => onBeforeLoadData();

    this.options.clearRowSelected = () => {
      this.options.selectedRows = [];
      selectedIds = {};
    };

    this.options.clearTable = (data) => {
      this.options.selectedRows = [];
      selectedIds = {};
      onBeforeLoadData();
      prepareData(data);

    };

    if (this.options.dataSource != null) {
      this.options.dataSource.onBeforeLoad(onBeforeLoadData);
      this.options.dataSource.onLoad(prepareData);
      this.options.dataSource.onError(onErrorData);
    }


    /**
     * funcion que inicializa o define variables
     * no definidas en los controladores de angular1
     */
    function prepareData(_data) {
      $("#" + options.id + " #checkAll").prop("checked", false);
      options.filterText = '';
      options.scrollPosition.id = "slider-step" + options.id;
      options.scrollPosition.isMobile = Util.isMobile();
      options.data = _data;
      options.visibleRows = options.data.length;
      options.loadingData.status = true;
      options.errorData.status = false;
      onLoadData(options.data);
    }

    ReactDOM.render(React.createElement(Table, { options: options }), element);

    function onLoadData(_data: any[]) {
      $("#" + options.id + " #checkAll").prop("checked", false);
      options.loadingData.status = false;
      options.errorData.status = false;
      options.data = _data;
      renderEmptyLine(options);
      ReactDOM.render(React.createElement(Table, { options: options }), element);
      tableData = _data;
      shift_IsPress = false;
      lastSelected = '';
      lastcheckId = '';
      setHorizontalScroll();
      paintSelectedRows();
      originalRows = $("#" + options.id + " tbody tr:gt(0)").toArray()
    };

    function onBeforeLoadData() {
      options.loadingData.status = true;
      options.errorData.status = false;
      options.data = [];
      let heightProgress = (options.columns.length > 0) ? options.columns.length : 1;
      (options.columns.length > 0 && options.multiSelect) ? heightProgress = options.columns.length + 1 : null;
      options.loadingData.height = heightProgress;
      ReactDOM.render(React.createElement(Table, { options: options }), element)
      $("#" + options.id + " #checkAll").prop("checked", false);
    };

    function onErrorData(_errorObject, _jqXHR, _simpleErrorMessage) {
      options.errorData.status = true;
      options.loadingData.status = false;

      let message = '';
      if (_jqXHR.errorMessage) {
        message = _jqXHR.errorMessage;
      }

      let numCols = (options.columns.length > 0) ? options.columns.length : 1;
      (options.columns.length > 0 && options.multiSelect) ? numCols = options.columns.length + 1 : null;

      let templateMessage = "<p id='no-select' class='text-center lead no-margin-bottom'><i class='md md-cloud-off text-xl text-danger'></i></br>" +
        "Ocurrio un error al intentar obtener los datos.</br>" +
        "<span id='no-select' class='text-xs'>" + message + '</span></p>' +
        "<a class='text-primary' id='tryAgain'>Reintentar</a>";

      options.errorData.content = templateMessage;
      options.errorData.height = numCols;

      ReactDOM.render(React.createElement(Table, { options: options }), element)
      $("#" + options.id + " #checkAll").prop("checked", false);
      //renderErrorData(_jqXHR);
    };


   

    options.watchEmptySelected = (newValue) => {
      emptySelection();
    };

    function emptySelection() {
      if (options.emptySelected == true) {
        tempList = [];
        options.selectedRows = [];
        selectedIds = {};
        options.emptySelected = false;
      }
    };

    let setHorizontalScroll=()=>{
      setTimeout(() =>{
        scrollArea = $("#" + options.id).parent();
        options.scrollPosition.max = scrollArea.prop("scrollWidth") - scrollArea.width();
        
        $(scrollArea).on('scroll', function (e) {
          options.scrollPosition.value = $(this).scrollLeft();
        });
        
        // $("#slider-step" + options.id).slider({
        //   value: 0, min: 0, max: options.scrollPosition.max, step: 1,
        //   slide: (event, ui) =>{
        //     this.options.scrollPosition.value = ui.value;
        //     this.moveHorizontalScroll();
        //   }
        // });
      });
    }

    function paintSelectedRows() {
      if (options.selectedRows.length > 0) {
        let rows = $("#" + options.id + " tbody tr");
        if (options.selectedRows.length > rows.length) {
          rows.each(function () {
            if (selectedIds.hasOwnProperty(this.id)) {
              $(this).addClass("active");
              $(this).find('input:checkbox').prop("checked", true);
            }
          })
          if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
            $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
          }

        } else {
          for (let key in selectedIds) {
            $("#" + options.id + " tbody tr#" + key).addClass("active").find('input:checkbox').prop("checked", true);
          }

          if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
            $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
          }
        }
      }
    }


    $(document).on('keydown', function (e) {
      shift_IsPress = e.shiftKey;

      if (shift_IsPress && e.keyCode == 40) {
        if (lastSelected !== '') {
          if ($("#" + options.id + " tbody tr").length > lastSelected + 1) {
            lastSelected = lastSelected + 1;
          }
          if ($("#" + options.id + " tbody tr").eq(lastSelected).length > 0) {
            if ($("#" + options.id + " tbody tr").eq(lastSelected).hasClass("active") && lastSelected < lastcheckId) {
              $("#" + options.id + " tbody tr").eq(lastSelected).removeClass("active");
              $("#" + options.id + " tbody tr").eq(lastSelected).find('input:checkbox').prop("checked", false);
              let id = $("#" + options.id + " tbody tr").eq(lastSelected)[0].id;
              removeRow(id)
              $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
            } else {
              $("#" + options.id + " tbody tr").eq(lastSelected).addClass("active");
              $("#" + options.id + " tbody tr").eq(lastSelected).find('input:checkbox').prop("checked", true);
              let id = $("#" + options.id + " tbody tr").eq(lastSelected)[0].id;
              addSelectedRow(id)
              if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
                $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
              }
            }
            let row = $("#" + options.id + " tbody tr").eq(lastSelected);
            let top = $(row).offset().top;
            let height = $(row).height() * 3;
            let scrollTop = top - height;
            if (top >= ($(window).height() - ($('.card-actionbar').height() * 2))) {
              $(window).scrollTop($(row).height() + $(window).scrollTop())

            }
          }
        }
      }

      if (shift_IsPress && e.keyCode == 38) {
        if (lastSelected !== '') {
          if ($("#" + options.id + " tbody tr").eq(lastSelected).length > 0) {
            if ($("#" + options.id + " tbody tr").eq(lastSelected).hasClass("active") && lastSelected > lastcheckId) {
              $("#" + options.id + " tbody tr").eq(lastSelected).removeClass("active");
              $("#" + options.id + " tbody tr").eq(lastSelected).find('input:checkbox').prop("checked", false);
              let id = $("#" + options.id + " tbody tr").eq(lastSelected)[0].id;
              removeRow(id);
              $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
            } else {
              $("#" + options.id + " tbody tr").eq(lastSelected).addClass("active");
              $("#" + options.id + " tbody tr").eq(lastSelected).find('input:checkbox').prop("checked", true);
              let id = $("#" + options.id + " tbody tr").eq(lastSelected)[0].id;
              addSelectedRow(id)
              if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
                $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
              }
            }
            let row = $("#" + options.id + " tbody tr").eq(lastSelected);
            let top = $(row).offset().top;
            let height = $(row).height() * 3;
            let scrollTop = top - height;
            if ((lastSelected - 1) >= 0) {
              lastSelected = lastSelected - 1;
            }
            $(window).scrollTop($(window).scrollTop() - $(row).height());
          }
        }
      }


    });



    $(document).on('keyup', function (e) {
      shift_IsPress = e.shiftKey;
    });

    tableEL.on("click", "#tryAgain", function () {
      options.dataSource.tryAgain();
    });

    $(tableEL).click(function (_event) {
      let browser = get_browser();
      if ((_event.target.id == "checkbox" || _event.target.id == "checkAll") && _event.target.nodeName == "SPAN" && browser == "Firefox") {
        _event.preventDefault();
        let cb = $(_event.target).siblings('input[type=checkbox]')[0];
        if (cb !== undefined) {
          $(cb).trigger('click');
        }
      }
    });

    tableEL.on("click", "input[type=checkbox]", function (_event) {
      let cb = $(this);
      let status = cb.is(":checked");

      if (this.id == 'checkAll') {
        if (options.data.length > 0) {
          if (status) {
            $("#" + options.id + " tbody tr").each(function (index) {
              if (!this.hidden) {
                $(this).addClass("active");
                addSelectedRow(this.id)
              }
            });
            $("#" + options.id + " tbody .ltableCheckbox").prop("checked", true);
          } else {
            $("#" + options.id + " tbody tr").each(function (index) {
              if (!this.hidden) {
                $(this).removeClass("active");
              }
              removeRow(this.id)
            });
            $("#" + options.id + " .ltableCheckbox").prop("checked", false);
          }
        }
        lastcheckId = '';
        lastSelected = lastcheckId;
      } else {
        if (shift_IsPress) {
          if (lastcheckId === '') {
            lastcheckId = $(this).parents('tr').index();
            lastSelected = lastcheckId;
          } else {

            if (lastcheckId < $(this).parents('tr').index()) {
              for (let i = Number(lastSelected); i < Number(lastcheckId); i++) {
                $("#" + options.id + " tbody tr").eq(i).removeClass("active");
                $("#" + options.id + " tbody tr").eq(i).find('input:checkbox').prop("checked", false);
                let id = $("#" + options.id + " tbody tr").eq(i)[0].id;
                removeRow(id);
                $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
              }

              if (lastSelected > $(this).parents('tr').index()) {
                for (let i = Number(lastSelected); i >= $(this).parents('tr').index(); i--) {
                  $("#" + options.id + " tbody tr").eq(i).removeClass("active");
                  $("#" + options.id + " tbody tr").eq(i).find('input:checkbox').prop("checked", false);
                  let id = $("#" + options.id + " tbody tr").eq(i)[0].id;
                  removeRow(id);
                  $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
                };
              }

              for (let i = Number(lastcheckId); i <= $(this).parents('tr').index(); i++) {
                if (!$("#" + options.id + " tbody tr").eq(i).attr("hidden")) {
                  $("#" + options.id + " tbody tr").eq(i).addClass("active");
                  $("#" + options.id + " tbody tr").eq(i).find('input:checkbox').prop("checked", true);
                  let id = $("#" + options.id + " tbody tr").eq(i)[0].id;
                  addSelectedRow(id)
                  lastSelected = i;
                  if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
                    $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
                  }
                }
              }
            } else {
              for (let i = Number(lastSelected); i > Number(lastcheckId); i--) {
                $("#" + options.id + " tbody tr").eq(i).removeClass("active");
                $("#" + options.id + " tbody tr").eq(i).find('input:checkbox').prop("checked", false);
                let id = $("#" + options.id + " tbody tr").eq(i)[0].id;
                removeRow(id);
                $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
              }

              if (lastSelected < $(this).parents('tr').index()) {
                for (let i = Number(lastSelected); i <= $(this).parents('tr').index(); i++) {
                  $("#" + options.id + " tbody tr").eq(i).removeClass("active");
                  $("#" + options.id + " tbody tr").eq(i).find('input:checkbox').prop("checked", false);
                  let id = $("#" + options.id + " tbody tr").eq(i)[0].id;
                  removeRow(id);
                  $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
                };
              }

              for (let i = lastcheckId; i >= $(this).parents('tr').index(); i--) {
                if (!$("#" + options.id + " tbody tr").eq(i).attr("hidden")) {
                  /*if (status) {*/
                  $("#" + options.id + " tbody tr").eq(i).addClass("active");
                  $("#" + options.id + " tbody tr").eq(i).find('input:checkbox').prop("checked", true);
                  let id = $("#" + options.id + " tbody tr").eq(i)[0].id;
                  addSelectedRow(id)
                  lastSelected = i;
                  if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
                    $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
                  }
                }
              }
            }

            _event.stopPropagation();
          }
        } else {

          if (status) {
            $('#' + options.id + " tbody tr").eq($(this).parents('tr').index()).addClass("active");
            lastcheckId = $(this).parents('tr').index();
            lastSelected = lastcheckId;
            addSelectedRow(this.id)
            if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
              $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
            }
          } else {
            $('#' + options.id + " tbody tr").eq($(this).parents('tr').index()).removeClass("active");
            $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
            removeRow(this.id);
            lastcheckId = '';
            lastSelected = '';
          }
        }
        _event.stopPropagation();
      }
      //getSelectedRows(); removido falta el shift
    });


    tableEL.on("click", "tbody tr", function (_event) {
      if (_event.target.id !== 'no-select') {

        if (options.multiSelect) {
          if (_event.target.id !== "checkbox" && _event.target.type !== "checkbox") {

            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).find("input:checkbox").prop("checked", false);
              removeRow(this.id);
              $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
            } else {
              $("#" + options.id + " tbody tr").eq($(this).index()).find('input:checkbox').prop("checked", true);
              $(this).addClass("active");
              addSelectedRow(this.id)
              lastcheckId = $(this).index();
              lastSelected = lastcheckId;
              if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
                $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
              }
            }
          }
        } else if (options.selectRow) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
          } else {
            (!options.multiSelect) ? $("#" + options.id + " tbody tr").removeClass("active") : null;
            $(this).addClass("active");
          }
        } else {
          $(this).removeClass("active");
        }
      }

    });

    tableEL.on('mousedown', 'tbody tr', function (e) {
      isMouseDown = true;
      if (!$(this).hasClass("active")) {
        listNotSelectedTr.push($(this).index());
      } else {
        listSelectedTr.push($(this).index());
      }

      if ($(e.target).prop("tagName") == "TD") {
        $(this).toggleClass("active");
        check(this);
      }

      return false;
    }).on('mouseover', 'tbody tr', function (e) {
      if (isMouseDown && !stop) {
        stop = true;
        if (!$(this).hasClass("active")) {
          listNotSelectedTr.push($(this).index());
        } else {
          listSelectedTr.push($(this).index());
        }

        $(this).toggleClass("active");
        check(this);
        stop = false;
      }
    }).on('mouseup', 'tbody tr', function (e) {
      isMouseDown = false;
      if (listNotSelectedTr.length > 0) {
        let idFirstTr = listNotSelectedTr[0];
        let idLastTr = listNotSelectedTr[listNotSelectedTr.length - 1];

        if (parseInt(idFirstTr) > parseInt(idLastTr)) {
          idFirstTr = listNotSelectedTr[listNotSelectedTr.length - 1];
          idLastTr = listNotSelectedTr[0];
        }

        for (let i = idFirstTr; i < idLastTr; i++) {
          if (!$("#" + options.id + " tbody tr:eq(" + i + ")").hasClass("active")) {
            $("#" + options.id + " tbody tr:eq(" + i + ")").addClass("active");
            check($("#" + options.id + " tbody tr:eq(" + i + ")")[0])
          }
        }
      }

      if (listSelectedTr.length > 0) {
        let idFirstTr = listSelectedTr[0];
        let idLastTr = listSelectedTr[listSelectedTr.length - 1];

        if (parseInt(idFirstTr) > parseInt(idLastTr)) {
          idFirstTr = listSelectedTr[listSelectedTr.length - 1];
          idLastTr = listSelectedTr[0];
        }

        for (let i = idFirstTr; i < idLastTr; i++) {
          if ($("#" + options.id + " tbody tr:eq(" + i + ")").hasClass("active")) {
            $("#" + options.id + " tbody tr:eq(" + i + ")").removeClass("active");
            check($("#" + options.id + " tbody tr:eq(" + i + ")")[0])
          }
        }
      }
      listNotSelectedTr = [];
      listSelectedTr = [];
    }).on("click", "tbody tr", function (_event) {
      if (_event.target.id !== 'no-select') {

        if (options.multiSelect) {
          if (_event.target.id !== "checkbox" && _event.target.type !== "checkbox") {
            //$('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);

            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).find("input:checkbox").prop("checked", false);
              removeRow(this.id);
              $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
            } else {
              $("#" + options.id + " tbody tr").eq($(this).index()).find('input:checkbox').prop("checked", true);
              $(this).addClass("active");
              addSelectedRow(this.id)
              lastcheckId = $(this).index();
              lastSelected = lastcheckId;
              if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
                $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
              }
            }
          }
        } else if (options.selectRow) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
          } else {
            (!options.multiSelect) ? $("#" + options.id + " tbody tr").removeClass("active") : null;
            $(this).addClass("active");
          }
        }

      }

    });

    $(document).bind('mouseup', function ($event) {
      isMouseDown = false;
      if (listNotSelectedTr.length > 0) {
        let idFirstTr = listNotSelectedTr[0];
        let idLastTr = listNotSelectedTr[listNotSelectedTr.length - 1];

        if (parseInt(idFirstTr) > parseInt(idLastTr)) {
          idFirstTr = listNotSelectedTr[listNotSelectedTr.length - 1];
          idLastTr = listNotSelectedTr[0];
        }

        for (let i = idFirstTr; i < idLastTr; i++) {
          if (!$("#" + options.id + " tbody tr:eq(" + i + ")").hasClass("active")) {
            $("#" + options.id + " tbody tr:eq(" + i + ")").addClass("active");
            check($("#" + options.id + " tbody tr:eq(" + i + ")")[0])
          }
        }
      }

      if (listSelectedTr.length > 0) {
        let idFirstTr = listSelectedTr[0];
        let idLastTr = listSelectedTr[listSelectedTr.length - 1];

        if (parseInt(idFirstTr) > parseInt(idLastTr)) {
          idFirstTr = listSelectedTr[listSelectedTr.length - 1];
          idLastTr = listSelectedTr[0];
        }

        for (let i = idFirstTr; i < idLastTr; i++) {
          if ($("#" + options.id + " tbody tr:eq(" + i + ")").hasClass("active")) {
            $("#" + options.id + " tbody tr:eq(" + i + ")").removeClass("active");
            check($("#" + options.id + " tbody tr:eq(" + i + ")")[0]);
          }
        }
      }
      listNotSelectedTr = [];
      listSelectedTr = [];
    });



    tableEL.on("click", "th", function (_event) {
      let table = $("#" + options.id);

      let icons = $(table).find('i').remove();
      let rows = table.find('tbody tr').toArray().slice().sort(comparer($(this).index()));
      let aux = originalRows;

      globalTh = $(_event.target);

      if (rows.length > 1) {
        if (options.orderBy == null) {
          if (this.sortType == undefined || this.sortType == "original") {
            this.sortType = "asc";
            globalsortType = this.sortType;
            $(_event.target).append('<i class="md md-arrow-drop-down"></i>');
          } else if (this.sortType == "asc") {
            this.sortType = "desc";
            globalsortType = this.sortType;
            rows = rows.reverse();
            $(_event.target).append('<i class="md md-arrow-drop-up"></i>');
          } else {
            this.sortType = "original";
            globalsortType = "";
            for (let i = 0; i < rows.length; i++) {
              rows[i] = aux[i];
            }
          }
          for (let i = 0; i < rows.length; i++) {
            table.append(rows[i]);
          }
        } else {
          if (this.sortType == undefined || this.sortType == "original") {
            this.sortType = "asc";
            globalsortType = this.sortType;
            $(_event.target).append('<i class="md md-arrow-drop-down"></i>');
          } else if (this.sortType == "asc") {
            this.sortType = "desc";
            globalsortType = this.sortType;
            $(_event.target).append('<i class="md md-arrow-drop-up"></i>');
          } else {
            this.sortType = "original";
            globalsortType = "";
          }
          sortFlag = true;

          if (this.sortType == "original") {
            options.orderBy($(_event.target).attr("name"), "");
          } else {
            options.orderBy($(_event.target).attr("name"), this.sortType);

          }
        }
      }
    });

    $(window).on('resize', (e)=> {
      if (options.hasOwnProperty('scrollPosition')) {
        scrollArea = $("#" + options.id).parent();
        options.scrollPosition.max = scrollArea.prop("scrollWidth") - scrollArea.width();
        options.scrollPosition.value = 0;
        $(scrollArea).on('scroll', function (e) {
          options.scrollPosition.value = $(this).scrollLeft();
        });

        $("#slider-step" + options.id).slider({
          value: 0, min: 0, max: options.scrollPosition.max, step: 1,
          slide: (event, ui) =>{
            this.options.scrollPosition.value = ui.value;
            this.moveHorizontalScroll();
          }
        });
      }
    });

    function comparer(index) {

    return function(a, b) {
      let valA=getCellValue(a,index),valB=getCellValue(b,index);
      return $.isNumeric(valA) && $.isNumeric(valB)?valA-valB:valA.localeCompare(valB);
    };
  }

    function getCellValue(row, index) {
      let value = $(row).children('td').eq(index);
      if (value[0] != null && value[0].innerText != null && value[0].innerText != "") {
        return value[0].innerText;
      } else {
        return value.html();
      }
    }

    function check(tr) {
      let check = $(tr).find("input:checkbox");

      if (check.prop("checked")) {
        check.prop("checked", false);
        removeRow(tr.id)
        $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", false);
      } else {
        check.prop("checked", true);
        addSelectedRow(tr.id)
        if ($("#" + options.id + " tbody tr").length == $("#" + options.id + " tbody tr.active").length) {
          $('#' + options.id + ' input:checkbox[id="checkAll"]').prop("checked", true);
        }
      }
    }


    function get_browser() {
      let ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE';
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) {
          return 'Opera'
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
      }
      return M[0];
    }

    function addSelectedRow(_id: number) {
      zone.run(() => {
        if (!selectedIds.hasOwnProperty(_id) && _id) {
          if (options.multiSelect == true) {
            options.selectedRows.push(getDataById(_id));
            selectedIds[_id] = options.selectedRows.length - 1;
          } else {
            options.selectedRows[0] = getDataById(_id);
            selectedIds[_id] = options.selectedRows.length - 1;
          }
        } else {
          this.options.clearRowSelected();
        }
        tempList = options.selectedRows;
      });
    }

    function getDataById(id: number) {
      for (let i = 0; i < options.data.length; i++) {
        if (options.data[i][options.rowId] == id) {
          return options.data[i];
        }
      }
    }

    function removeRow(_id: number) {
      zone.run(() => {
      for (let i = 0; i < options.selectedRows.length; i++) {
        let iter = options.selectedRows[i];

        for (let j in iter) {
          if (iter[j] == _id) {
            options.selectedRows.splice(i, 1);
            break;
          }
        }
      }

      delete selectedIds[_id];
      });
    }
  }

  renderEmptyLine(options?: TableOptions) {

    let obj: TableOptions;

    if (options != null) {
      obj = options;
    } else {
      obj = this.options;
    }

    let numCols = (obj.columns.length > 0) ? obj.columns.length : 1;
    (obj.columns.length > 0 && obj.multiSelect) ? numCols = obj.columns.length + 1 : null;

    let _emptyText = "<p class='lead' id='no-select'>No se encuentran registros.</br></p>";

    let trEmptyLine = "<tr><td id='no-select' class='height-6 text-center' colspan=" + numCols + ">" + _emptyText + "</td></tr>";

    obj.emptyData.content = trEmptyLine;
    obj.errorData.height = numCols;
  };
  
  
  /**
   * metodo para mover la grilla con su scroll horizontal
   */
  private moveHorizontalScroll(){
      if (this.options.hasOwnProperty('scrollPosition')) {
        let scrollArea: any = $("#" + this.options.id).parent();
        $(scrollArea).scrollLeft(this.options.scrollPosition.value);

        if (this.options.scrollPosition.max == 0) {
          $("#slider-step" + this.options.id).closest('.form-group').css("display", "none");
        } else {

          $("#slider-step" + this.options.id).closest('.form-group').css("display", "block");
          $("#slider-step" + this.options.id + "> span").css("left", (this.options.scrollPosition.value / this.options.scrollPosition.max) * 100 + "%");
        }
      }
  }

  ngOnInit() {
    this.link();
  }

  ngAfterViewInit() {
    this.onReady.emit(this.options);
  }
    
  ngDoCheck() {
    if (JSON.stringify(this.options.columns) !== JSON.stringify(this.oldOptions.columns)) {

      this.renderEmptyLine();
      $("#" + this.options.id + " #checkAll").prop("checked", false);
      ReactDOM.render(React.createElement(Table, { options: this.options }), this.element.nativeElement);


      this.oldOptions.columns = this.options.columns.slice();
    }
    
    
    if (JSON.stringify(this.options.scrollPosition) != JSON.stringify(this.oldOptions.scrollPosition)) {
      this.moveHorizontalScroll();
      this.oldOptions.scrollPosition.max = this.options.scrollPosition.max;
      this.oldOptions.scrollPosition.value = this.options.scrollPosition.value;
    }
    
    
    if (this.options.filterText != this.oldOptions.filterText){
        $(this.element.nativeElement).find("tbody tr").hide();
        $(this.element.nativeElement).find("tbody tr td").filter((index:number,td:Element)=>{
            
            let isFiltered: boolean = $(td).text().toLowerCase().indexOf(this.options.filterText.toLowerCase()) !== -1;
            
            if(isFiltered) $(td).parent().show();
            
        });
        this.oldOptions.filterText = this.options.filterText;
        
    } 
  }
}